import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function CategoryNav() {
  return (
    <section className="bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-6 md:py-8">
        <div className="flex items-center justify-between mb-5">
          <h2 className="text-lg md:text-xl font-heading font-bold text-foreground-950">分类导航</h2>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group bg-background-50 rounded-lg p-5 border border-secondary-200/70 hover:border-primary-300/60 transition-all duration-300 flex flex-col items-center text-center"
            >
              <div className="w-12 h-12 rounded-full bg-primary-100 flex items-center justify-center mb-3 group-hover:bg-primary-500 transition-colors duration-300">
                <i className={`${cat.icon} text-xl text-primary-600 group-hover:text-background-50 transition-colors duration-300`}></i>
              </div>
              <span className="text-sm font-semibold text-foreground-800 mb-1 whitespace-nowrap">{cat.name}</span>
              <span className="text-xs text-foreground-500 line-clamp-2 leading-relaxed">{cat.description}</span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}